import { categories } from '@/mocks/site';

interface CategoryNavProps {
  active: string;
  onSelect: (slug: string) => void;
}

export default function CategoryNav({ active, onSelect }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-all cursor-pointer ${
            active === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}